import type { ReactElement } from 'react';

/**
 * Aviso slim, no bloqueante, de pérdida de red. La app sigue usable con lo
 * último cacheado por el service worker; esto sólo informa. Se renderea sólo
 * mientras `navigator.onLine` es false (ver PwaLayer).
 */
export function OfflineBanner(): ReactElement {
  return (
    <div className="pwa-offline" role="status" aria-live="polite">
      <span className="pwa-offline__dot" aria-hidden="true" />
      <span className="pwa-offline__text">Sin conexión — seguís con lo último cargado.</span>
    </div>
  );
}
